/**
 * Created by Bob.Gear on 11/03/14.
 */
//------------------------------------------------------------------------
//  fullTextFilter Directive
//------------------------------------------------------------------------
angular.module("EICDataStream3.queryBuilder")
  .controller('fullTextFilterController', [
    '$scope', 'keywordsService',
    function($scope, keywordsService) {
      $scope.componentName = "fullTextFilter";

      $scope.resetFilter = function() {
        $scope.clearFullText();
      };

      $scope.clearFullText = function() {
        keywordsService.clearKeywords();
        delete $scope.criteria["fullText"];
      };

      $scope.removeFullTextFilter = function() {
        $scope.resetFilter();
        $scope.$parent.removeFilter("#fullTextFilter");
      };

      $scope.$watch("criteria.fullText", function() {
        keywordsService.setKeywords($scope.criteria.fullText);
      });

    }
  ])
  .directive('fullTextFilter', [
    function() {
      return {
        replace: true, // replace the placeholder element with the template
        restrict: 'A', // usage: <div project-name-filter />
        templateUrl: "../app-ds3/search/queryBuilder/filters/fullTextFilter.tmpl.html",

        link: function($scope, iElement, iAttrs) {
          var txtFullText = iElement.find('#txtFullText');
          txtFullText.attr('placeholder', txtFullText.attr('placeholder-text'));
        },

        controller: 'fullTextFilterController'
      };
    }
  ])
  // .service('keywordsService', [
  // function() {

  //   var tokenize = function(keywords) {

  //     //   keywords = keywords.replace(new RegExp(',$', 'g'), '').split(',');
  //     keywords = keywords.replace(new RegExp(' $', 'g'), ' ').split(' ');
  //     var i;
  //     var l = keywords.length;
  //     for (i = 0; i < l; i++) {
  //       keywords[i] =  keywords[i].replace(new RegExp('^ | $', 'g'), ''); // + '\\b';'\\b' +
  //     }
  //     return keywords;
  //   };

  //   this.replacer = function(match, item) {
  //     //return '<span class="' + attrs.highlightClass + '">' + match + '</span>';
  //     return '<span style="background-color:yellow">' + match + '</span>';
  //   };


  //   this.setKeywords = function(keywords){
  //     if (!keywords || keywords.length==0) return "";

  //     this.keywords = keywords;

  //     var tokenized = tokenize(keywords);
  //     this.regex = new RegExp(tokenized.join('|'), 'gmi');
  //   }

  //   this.clearKeywords = function(){
  //    this.keywords = null;
  //   }
  // }
// ]);
//------------------------------------------------------------------------

